import { createSelector } from '@ngrx/store';
import { AppStateInterface } from '../types';

export const selectProfileData = (state: AppStateInterface) =>
  state.profileData;

export const isLaodingProfileDataSelector = createSelector(
  selectProfileData,
  (state) => state.isLoading,
);
export const successProfileDataSelector = createSelector(
  selectProfileData,
  (state) => state.profileData,
);
export const errorProfileDataSelector = createSelector(
  selectProfileData,
  (state) => state.error,
);
